export const PRODUCTION_DOMAIN = 'www.alluradirect.com';
export const EMAIL_INFO = 'info@alluradirect.com';
export const EMAIL_ACCOUNTS = 'accounts@alluradirect.com';
